"use client";

import { useEffect, useState, useRef } from "react";
import useStore from "@/store/useStore";
import { PreviewModeProvider } from "@/components/providers/PreviewModeProvider";

export default function SpaceLayoutClient({ children }) {
  const { session } = useStore();
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [isViewOnlyMode, setIsViewOnlyMode] = useState(false);
  const urlCheckedRef = useRef(false);

  // Check if we're in preview mode from URL
  useEffect(() => {
    // Only run this once per session to prevent redundant processing
    if (urlCheckedRef.current && session) {
      return;
    }

    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const previewParam = urlParams.get("preview");
      const viewOnlyParam = urlParams.get("view_only");

      setIsPreviewMode(previewParam === "true");
      setIsViewOnlyMode(viewOnlyParam === "true");

      // Mark URL as checked for this session to prevent redundant processing
      if (session) {
        urlCheckedRef.current = true;
      }
    }
  }, [session]);

  // Log special mode status only once when activated
  useEffect(() => {
    const modes = {
      preview: isPreviewMode,
      viewOnly: isViewOnlyMode,
    };

    // Use the ref to track what we've already logged
    if (!window._loggedModes) {
      window._loggedModes = {};
    }

    // Only log when a mode is activated and hasn't been logged before
    Object.entries(modes).forEach(([mode, isActive]) => {
      if (isActive && !window._loggedModes[mode]) {
        if (mode === "preview" || mode === "viewOnly") {
          console.log(
            "Space non-editable mode active - showing as non-authenticated view"
          );
        }
        window._loggedModes[mode] = true;
      } else if (!isActive) {
        // Reset logged state when mode is deactivated
        window._loggedModes[mode] = false;
      }
    });
  }, [isPreviewMode, isViewOnlyMode]);

  return <PreviewModeProvider>{children}</PreviewModeProvider>;
}
